import { render } from "./NovusLayout.vue?vue&type=template&id=33edd8a2"
import script from "./NovusLayout.vue?vue&type=script&lang=js"
export * from "./NovusLayout.vue?vue&type=script&lang=js"

import exportComponent from "/opt/novus-cloud-ui/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__